type Props = {
  reversed?: boolean
  className?: string
}

const LEFT_FACING_PATH =
  'M191.7,53.8c0,0,0.5-13,2.8-18.7l-1.7-0.8h2.6l-0.3-5c0,0-0.8-0.8-1.7-0.7c0,0-11,9.2-12,17.4\nc0,0-16.7-11.2-41-16.5l0.2-0.8c0,0-2.9-2.1-3.7-3.4c0,0-4.1-5.5-2.7-12.6l1.9-2.6c0,0,0.8-6,2-8.7c0,0-0.3-5.6-17.2,11.3\nc0,0-4.1,5.8-6,9.3c0,0-1.2,2.6-8.3,2.2c0,0-29.2,0-50.1,7.9c0,0-40.6,12.3-56,25.9c0,0,2.1,11,24.8,9.5l2.7-0.8l3.4-1.3l1.9-0.5\nl0.8,0.8c0,0-1.1,0.3-2.1,0.1c0,0-0.6,1.4,0.4,1.9c0,0-1.7-0.2-2.2-0.9c0,0-0.1,1.3,0.8,1.8c0,0-1.3-0.2-2-0.8c0,0,0.2,1.4,0.5,1.4\nc0,0-1.1,0.2-1.8,0c0,0,0,1.3,1.9,1.4c0,0-2.2,2,3.4,2.9c0,0,9.8,2.7,18.5,2.6c0,0,19.2,1,30.2-2.6c0,0,2.5,11.6,13.9,7.4\nc0,0-0.3-7.7,11.9-12c0,0,27.3-2.5,40.7-6l3.9,4.6l1.7-0.3c0,0,1.4-2,3.5-2.9c0,0,25.9,0.3,6.5-2.3l-1.4-1.7c0,0,4.8-0.5,9.9-0.6\nl4,1.5l-2.3-3.1l3.1,1.4v-3.4h4.8c0,0,8.6,19.4,20.5,23.6C202.4,79.5,195.1,70.4,191.7,53.8z'

const RIGHT_FACING_PATH =
  'M11.2,53.8c0,0-0.5-13-2.8-18.7l1.7-0.8H7.5l0.3-5c0,0,0.8-0.8,1.7-0.7c0,0,11,9.2,12,17.4\nc0,0,16.7-11.2,41-16.5l-0.2-0.8c0,0,2.9-2.1,3.7-3.4c0,0,4.1-5.5,2.7-12.6l-1.9-2.6c0,0-0.8-6-2-8.7c0,0,0.3-5.6,17.2,11.3\nc0,0,4.1,5.8,6,9.3c0,0,1.2,2.6,8.3,2.2c0,0,29.2,0,50.1,7.9c0,0,40.6,12.3,56,25.9c0,0-2.1,11-24.8,9.5l-2.7-0.8l-3.4-1.3l-1.9-0.5\nl-0.8,0.8c0,0,1.1,0.3,2.1,0.1c0,0,0.6,1.4-0.4,1.9c0,0,1.7-0.2,2.2-0.9c0,0,0.1,1.3-0.8,1.8c0,0,1.3-0.2,2-0.8c0,0-0.2,1.4-0.5,1.4\nc0,0,1.1,0.2,1.8,0c0,0,0,1.3-1.9,1.4c0,0,2.2,2-3.4,2.9c0,0-9.8,2.7-18.5,2.6c0,0-19.2,1-30.2-2.6c0,0-2.5,11.6-13.9,7.4\nc0,0,0.3-7.7-11.9-12c0,0-27.3-2.5-40.7-6l-3.9,4.6l-1.7-0.3c0,0-1.4-2-3.5-2.9c0,0-25.9,0.3-6.5-2.3l1.4-1.7c0,0-4.8-0.5-9.9-0.6\nl-4,1.5l2.3-3.1l-3.1,1.4v-3.4H21c0,0-8.6,19.4-20.5,23.6C0.5,79.5,7.8,70.4,11.2,53.8z'

const Shark = ({ reversed = false, className }: Props) => (
  <svg
    className={className}
    x="0"
    y="0"
    viewBox="0 0 202.9 82.3"
  >
    <path
      fill="#E3F0F7"
      stroke="#2E7EC8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d={reversed ? LEFT_FACING_PATH : RIGHT_FACING_PATH}
    />
  </svg>
)

export default Shark
